import { Component } from '@angular/core';
import { CurriculumSessionFormComponent } from '../curriculum-session-form/curriculum-session-form.component';

@Component({
  selector: 'app-curriculum-sessions-review',
  template: `<app-curriculum-session-form mode="review"></app-curriculum-session-form>`,
  standalone: true,
  imports: [CurriculumSessionFormComponent],
})
export class CurriculumSessionsReviewComponent {}
